import React from "react";
import { Container, Row, Col, Jumbotron } from "reactstrap";
import styles from "./IconsWithDescription.module.scss";

const IconsWithDescription = ({ background, headline, icons = [], style = {} }) => {
  return (
    <div
      className={background === "white" ? `${styles.sectionWidth} bg-white` : styles.sectionWidth}
      style={style}
    >
      <Container>
        <Row>
          <Col md={12} className="mb-4 text-center text-md-left">
            <h3>{headline}</h3>
          </Col>
          {icons.map((icon) => {
            const Tag = icon.href ? "a" : "span";
            return (
              <Col key={icon.image} xs={6} md={2} className={`${styles.imgText} px-4 pt-2`}>
                {!React.isValidElement(icon) ? (
                  <Tag href={icon.href} target={icon.target} rel={icon.rel}>
                    <img src={icon.image} className={`${styles.iconImg} mb-4`} alt="" />
                    <p className="text-center text-md-left">{icon.text}</p>
                  </Tag>
                ) : (
                  icon
                )}
              </Col>
            )
          })}
        </Row>
      </Container>
    </div>
  );
};

export default IconsWithDescription;
